﻿export interface ISerologySearchRequest {
    centerId: number;
    dateStatus: number,
    serologyStatus: number,
    filterStartDate: string,
    filterEndDate: string
}
